import React from 'react';
import PropTypes from 'prop-types';
import { noop } from '../../../../../lib/utilities';
import { FormattedPrice } from '../../price/formatted_price';
import { RowTwoCells } from './row_two_cells';
import { Label } from './shipping_price/label';
import Translation from '../../translation/translation';

export function Price({
    name,
    label,
    lightLabel,
    price,
    currencyIsoCode,
    overrides,
    loading,
    isSub,
    hasBorder,
    noBottomPadding,
    hasPaddingBottom,
    labelExtraChildren,
    priceExtraChildren,
    onLabelClick,
    onComponentClick,
    leftClassName,
    className,
    isTotalPrice,
    middle,
    colspan,
}) {
    const labelName = name.split(' ')[0];
    const left = [
        <div className={leftClassName}>{
            [
                <Label name={labelName} lightLabel={lightLabel} label={label} key="Label" onClick={onLabelClick} />,
                ...labelExtraChildren
            ]}</div>
    ];

    const right = price !== undefined ? [
        <FormattedPrice
            price={price}
            currencyIsoCode={currencyIsoCode}
            className={`${labelName}__price ${className}`}
            loading={loading}
            key="price"
            inCents={true}
            overrides={overrides}
            isTotalPrice={isTotalPrice}
        />,
        ...priceExtraChildren
    ] : '';

    const leftTotalText = <Translation translationKey={'cart-sidebar-gift-card-remainder-text'} />;

    return (
        <>
            <RowTwoCells
                key={name}
                name={name}
                isSub={isSub}
                hasBorder={hasBorder}
                noBottomPadding={noBottomPadding}
                hasPaddingBottom={hasPaddingBottom}
                onComponentClick={onComponentClick}
                left={left}
                middle={middle}
                right={right}
                colspan={colspan}
            />
            {price < 0 && <RowTwoCells
                key={name}
                name={name}
                left={leftTotalText}
                right={''}
            />}
        </>
    );
}

const extraChildrenPropType = PropTypes.arrayOf(PropTypes.element);

Price.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
    ]).isRequired,
    price: PropTypes.number,
    currencyIsoCode: PropTypes.string,
    loading: PropTypes.bool,
    lightLabel: PropTypes.bool,
    isSub: PropTypes.bool,
    hasBorder: PropTypes.bool,
    noBottomPadding: PropTypes.bool,
    leftClassName: PropTypes.string,
    className: PropTypes.string,
    hasPaddingBottom: PropTypes.bool,
    labelExtraChildren: extraChildrenPropType,
    priceExtraChildren: extraChildrenPropType,
    overrides: PropTypes.object,
    onLabelClick: PropTypes.func,
    onComponentClick: PropTypes.func,
};

Price.defaultProps = {
    loading: false,
    lightLabel: false,
    isSub: false,
    hasBorder: true,
    noBottomPadding: false,
    hasPaddingBottom: true,
    labelExtraChildren: [],
    priceExtraChildren: [],
    overrides: {},
    onLabelClick: noop,
    onComponentClick: noop,
};
